import React from 'react';
import Heading from 'js/components/Common/Heading/Heading';
import Container from 'js/components/Common/Container/Container';
import ContactForm from 'js/components/Common/ContactForm/ContactForm';

import classes from './ContactBlock.module.pcss';
import ContactInfo from './ContactInfo/ContactInfo';

const ContactBlock = ({pageId}) => (
	<div className={classes.ContactBlock}>
		<Container additionalClass={classes.Wrapper}>
			<Heading text={'Contact Us'} type={'h1'}/>
			<ContactForm type={'contactForm'}/>
			<ContactInfo pageId={pageId}/>
		</Container>
	</div>
);

export default ContactBlock;

